// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3KfCf","calendarButtons":"ClockData_calendarButtons__3Pd9t"};